import ACField from './components/ACField.vue';

export default {
  components: { ACField },
  data() {
    return {
      pagePers: null,
      dialogPers: false,
      fields: [],
      ndflData: {
        last_name: '',
        first_name: '',
        middle_name: '',
      },
      form: {
        loaded: false,
      },
      suggestions: [],
      suggestions_items: [],
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    user() {
      return this.$store.state.user;
    },
    requirePers() {
      return this.user
        && this.$store.state.settings.profile_pers === true
        && !this.$store.state.user.pers_at;
    },
    account() {
      return this.$store.state.user.account;
    },
  },
  methods: {
    ConfirmPers() {
      const app = this;
      app.$store.getters.axl.post('profiles/api/auth/confirm-pers', { profile_id: app.user.profile_id })
        .then(() => {
          app.user.pers_at = true;
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    LoadPers() {
      const app = this;
      console.log('app.user.phone', app.user);
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone_mobile })
        .then((response) => {
          app.pagePers = response.data.pagePers;
        });
    },
    async LoadPassport() {
      const app = this;
      try {
        const fieldsData = await app.$store.getters.axl.post('taxes/api/forms/fields', { profile_id: app.user.profile_id });
        app.fields = fieldsData.data.fields;
        const profileTaxInfoResponse = await app.$store.getters.ax.post('taxes/api/forms/get', { profile_id: app.user.profile_id });
        const profileTaxInfo = profileTaxInfoResponse.data.form;

        if (profileTaxInfo) {
          app.ndflData = profileTaxInfo;
          delete app.ndflData.document1;
          delete app.ndflData.document2;

          app.form.comments = profileTaxInfo.comments;
        } else {
          app.ndflData.last_name = app.user.last_name;
          app.ndflData.first_name = app.user.first_name;
          app.ndflData.middle_name = app.user.middle_name;
        }

        const fieldsLength = app.fields.length;
        for (let i = 0; i < fieldsLength; i += 1) {
          this.$set(this.$data.form, app.fields[i].name, app.ndflData[app.fields[i].name]);
          if (app.fields[i].type === 'file') {
            this.$set(this.$data.form, app.fields[i].name, {
              filename: profileTaxInfo ? profileTaxInfo[`${app.fields[i].name}`] : '',
              base64: profileTaxInfo ? profileTaxInfo[`${app.fields[i].name}_file`] : '',
              name: '',
              url: '',
              id: null,
            });
          }
        }
        console.log('app.fields', app.fields);
        app.form.loaded = true;
      } catch (error) {
        this.$store.dispatch('HandleError', error);
      }
    },
    SetACField(e) {
      this.$set(this.$data.form, e.inputName, e.address);
      this.$set(this.$data.form, `${e.inputName}_data`, e.data);
    },
    LoadFromUser() {
      this.form.last_name = this.user.last_name;
      this.form.first_name = this.user.first_name;
      this.form.middle_name = this.user.middle_name;
    },
    PickDocument(name) {
      this.$refs[name][0].click();
    },
    OnDocument(e, name) {
      this.OnFilePicked(e, name);
    },
    OnFilePicked(e, name) {
      const app = this;
      const { files } = e.target;
      if (files[0] !== undefined) {
        app.form[name].filename = files[0].name;
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          app.form[name].base64 = fr.result;
          app.$forceUpdate();
        });
        console.log('form: ', app.form, 'file: ', files);
      }
    },
    SavePassport() {
      const app = this;
      const data = {};
      data.profile_id = app.user.profile_id;
      data.data = app.form;

      app.$store.getters.axl.post('taxes/api/forms/save', data)
        .then((response) => {
          app.$store.dispatch('ShowInfo', 'Анкета сохранена!');
          console.log(response.data);
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
  },
  async mounted() {
    await this.$store.dispatch('GetProfile');
    await this.LoadPassport();
    if (this.requirePers) {
      this.LoadPers();
    }
  },
};
